/**
 * Festival Date Mapping for Vietnamese Holidays
 * Auto-select date when festival is selected
 */

// Lunar date format: { lunarDay, lunarMonth }
export interface LunarDate {
    lunarDay: number;
    lunarMonth: number;
}

// Festival to Lunar Date mapping
export const FESTIVAL_LUNAR_DATES: Record<string, LunarDate> = {
    'Tết Nguyên Đán': { lunarDay: 1, lunarMonth: 1 },
    'Tết Trung Thu': { lunarDay: 15, lunarMonth: 8 },
    'Tết Đoan Ngọ': { lunarDay: 5, lunarMonth: 5 },
    'Rằm tháng Giêng': { lunarDay: 15, lunarMonth: 1 },
    'Rằm tháng 7': { lunarDay: 15, lunarMonth: 7 },
    'Tết Hàn Thực': { lunarDay: 3, lunarMonth: 3 },
    'Vu Lan': { lunarDay: 15, lunarMonth: 7 },
};

/**
 * Get the lunar date for a festival
 * Returns null if festival is not in the mapping (e.g., "Khác")
 */
export const getFestivalLunarDate = (festivalName: string): LunarDate | null => {
    return FESTIVAL_LUNAR_DATES[festivalName] || null;
};

/**
 * Check if a festival has a fixed lunar date
 */
export const isFestivalWithFixedDate = (festivalName: string): boolean => {
    return festivalName in FESTIVAL_LUNAR_DATES;
};
